import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ProtocolData } from 'src/lib/fliko/models/agreements/protocol.data';
import { Nullish } from 'src/lib/fliko/types/typeish.type';
import { UpdateIdOnly } from 'src/lib/fliko/types/update.type';
import { DatabaseService } from 'src/app/shared/services/database.service';

@Injectable({ providedIn: 'root' })
export class ProtocolService {
  constructor(private dbSrv: DatabaseService) {}

  /**
   * @path /protocol/$estateId/
   * @key id
   */
  private get protocol() {
    return this.dbSrv.estateFactory.getCollection<ProtocolData>('protocol/$eId');
  }

  private protocolByAgreement = (agrId: string) =>
    this.dbSrv.estateFactory.getCollectionReadOnly<ProtocolData>('protocol/$eId', {
      by: { child: 'agreementId' },
      equalTo: agrId
    });

  public getAllProtocols$(): Observable<ProtocolData[]> {
    return this.protocol.getList();
  }

  public getProtocol$(id: string): Observable<ProtocolData | Nullish> {
    return this.protocol.getElement(id);
  }

  public getAgreementProtocols$(agreementId: string): Observable<ProtocolData[]> {
    return this.protocolByAgreement(agreementId).getList();
  }

  public setProtocol(protocol: ProtocolData): Promise<void> {
    return this.protocol.setElement(protocol.id, protocol);
  }

  public updateProtocol(protocol: UpdateIdOnly<ProtocolData>): Promise<void> {
    return this.protocol.updateElement(protocol.id, protocol);
  }
}
